import React from "react";

const Footer = () => {
  return (
    <footer id="footer" className="footer">
      <span>
        Developed by
        <a
          href="https://angelygranados.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Angely Granados
        </a>
      </span>
    </footer>
  );
};

export default Footer;
